// extracted by mini-css-extract-plugin
export default {"appWrapper":"ChatApp_appWrapper__qhLde","chatMainPanel":"ChatApp_chatMainPanel__8dgtv"};